var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-item',{attrs:{"title":_vm.title}},[_c('el-radio-group',{model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}},_vm._l((_vm.data),function(r){return _c('el-radio',{key:r.value,staticClass:"c-version-item",attrs:{"label":r.value}},[_vm._v(_vm._s(r.label))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }